// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import React, { useEffect, useRef, useState } from 'react';

import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import Button from '@cloudscape-design/components/button';
import Container from '@cloudscape-design/components/container';
import Form from '@cloudscape-design/components/form';
import FormField from '@cloudscape-design/components/form-field';
import Header from '@cloudscape-design/components/header';
import Input, { InputProps } from '@cloudscape-design/components/input';


import { Link } from '@cloudscape-design/components';
import SpaceBetween from '@cloudscape-design/components/space-between';
import { mdiCheckCircle, mdiEyeOffOutline, mdiEyeOutline } from '@mdi/js';
import { Icon } from '@mdi/react';
import Favorites from '../../../../components/extras/Favorites';
import { addNotification, base64Encode, buildBreadcrumbItems, getCookie, getUrlVersion, setData, setLoading } from '../../../commons/functions';
import { useGlobalState } from '../../../context/GlobalStateContext';
import { CustomAppLayout } from '../../layout';
import { useRouter } from '../../router';
import { useStore } from '../../store';

export const UserPasswordPage = () => {
    const { menu } = useGlobalState();

    const [inputPassword1, setInputPassword1] = useState('');
    const [inputPassword2, setInputPassword2] = useState('');
    const [isDisabledBtnMod, setIsDisabledBtnMod] = useState(true);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [type1, setType1] = useState(false);
    const [type2, setType2] = useState(false);

    const [errors, setErrors] = useState<string[]>([]);
    const inputRef = useRef<HTMLInputElement>(null);
    const inputRef1 = useRef<HTMLInputElement>(null);
    const inputRef2 = useRef<HTMLInputElement>(null);
    /*
      const onJobNameChangePhone = (event: any) => {
        setJobName(event.detail.value);
        setMessages([]);
      };
      */
    const handleInputPassword1: InputProps["onChange"] = (event) => {
        setInputPassword1(event.detail.value);
        validatePassword(event.detail.value);
    };
    const handleInputPassword2: InputProps["onChange"] = (event) => {
        setInputPassword2(event.detail.value);
        validatePassword(inputPassword1)

    };

    const [shouldRedirect, setShouldRedirect] = useState(false);
    useEffect(() => {
        if (shouldRedirect && getCookie("JWT") !== "") {
        }

    }, [shouldRedirect]);



    const handleValidateNewPasword = async () => {
        if (inputPassword1 == '') {
            addNotification('Nueva contraseña inválida', 'error', setData);
            return
        }
        if (inputPassword1 !== inputPassword2) {
            addNotification('Nueva contraseña y confirmación no coinciden', 'error', setData);
            return
        }

        try {
            setLoading(true);
            const response = await fetch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/user/profile/mod.pwd',
                    'JWT': getCookie("JWT"),
                    // 
                },
                body: JSON.stringify({
                    newPassword: base64Encode(inputPassword1),
                }),

            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            if (data.code == 0) {
                setShowNewPassword(false)
                addNotification('Contrseña ha sido modificada', 'success', setData);
                setInputPassword1('');
                setInputPassword2('');
            } else {
                addNotification(data.status, 'error', setData);
            }
        } catch (error: any) {
            addNotification(`Error al contactar el servidor: ${error.message}`, 'error', setData);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        setIsDisabledBtnMod(errors.length > 0 || (inputPassword1 !== inputPassword2 && inputPassword1.length > 0))
    }, [errors]);

    const validatePassword = (passwordToCheck: string) => {
        const newErrors: string[] = [];
        if (passwordToCheck.length < 8) {
            newErrors.push('Al menos 8 caracteres');
        }

        if (!/[#\$%\^&\*\(\)\-\+\=\[\]\{\}\\\|\;\:\'\"\,\<\>\.\/\?]/.test(passwordToCheck)) {
            newErrors.push('Debe incluir al menos un símbolo (ej: # $ . ?)');
        }
        if (!/(?=.*[a-z])/.test(passwordToCheck)) {
            newErrors.push('Debe incluir al menos una letra minúscula');
        }
        if (!/(?=.*[A-Z])/.test(passwordToCheck)) {
            newErrors.push('Debe incluir al menos una letra mayúscula');
        }
        if (!/(?=.*\d)/.test(passwordToCheck)) {
            newErrors.push('Debe incluir al menos un número');
        }
        if (!/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#\$%\^&\*\(\)\-\+\=\[\]\{\}\\\|\;\:\'\"\,\<\>\.\/\?])/.test(passwordToCheck)) {
            //   newErrors.push('Debe incluir una mezcla de letras mayúsculas y minúsculas, números y símbolos');
        }

        setErrors(newErrors);
    }

    const {
        actions: { makeHelpPanelHandler },
    } = useStore();
    const { navigate } = useRouter();
    const createJob = () => {
        //setPendingJobCreation(true);
        //setTimeout(() => navigate('transcription-job-list'), 1000);
    };


    return (
        <>
            <CustomAppLayout
                breadcrumbs={
                    <BreadcrumbGroup
                        items={buildBreadcrumbItems(menu)}
                        expandAriaLabel="Show path"
                        ariaLabel="Breadcrumbs"
                    />
                }
                toolsHide={true}
                contentType="form"
                content={
                    <form onSubmit={event => event.preventDefault()}>
                        <Form
                            header={
                                <Header variant="h1"
                                    actions={<Favorites />}
                                >Modificar contraseña
                                </Header>
                            }
                        >
                            <SpaceBetween size="xl">
                                <Container header={''}>
                                    <SpaceBetween size="l">
                                        <FormField label="Nueva contraseña"

                                            info={inputPassword1.length > 0 && (<Link onClick={() => setType1(!type1)}>{type1 ? <Icon path={mdiEyeOutline} size={1} /> : <Icon path={mdiEyeOffOutline} size={1} />}</Link>)}

                                            errorText={errors.length > 0 ?
                                                errors.map((error, index) => (
                                                    <React.Fragment key={index}>
                                                        {error}
                                                        <br /> {/* Use <br /> for line breaks within the Alert */}
                                                    </React.Fragment>
                                                ))
                                                : undefined}
                                        >
                                            <SpaceBetween direction="vertical" size="xs">
                                                <SpaceBetween direction="horizontal" size="xs">
                                                    <Input
                                                        controlId='infoPassword1'
                                                        value={inputPassword1}
                                                        type={type1 ? 'text' : 'password'}
                                                        onChange={handleInputPassword1}
                                                        ref={inputRef1}
                                                        autoComplete="off"
                                                    />
                                                    {errors.length === 0 && inputPassword1.length > 0 ?
                                                        (<>
                                                            <Icon path={mdiCheckCircle} size={1} color={"green"} />
                                                        </>) : null
                                                    }
                                                </SpaceBetween>
                                            </SpaceBetween>
                                        </FormField>

                                        <FormField label="Confirmación"
                                            errorText={inputPassword2.length > 0 && inputPassword1 !== inputPassword2 ? 'La confirmación no coincide con la nueva contraseña' : undefined}
                                            info={inputPassword2.length > 0 && (<Link onClick={() => setType2(!type2)}>{type2 ? <Icon path={mdiEyeOutline} size={1} /> : <Icon path={mdiEyeOffOutline} size={1} />}</Link>)}
                                        >

                                            <SpaceBetween direction="horizontal" size="xs">
                                                <Input
                                                    controlId='infoPassword2'
                                                    value={inputPassword2}
                                                    type={type2 ? 'text' : 'password'}
                                                    onChange={handleInputPassword2}
                                                    ref={inputRef2}
                                                    autoComplete="new-password"
                                                />
                                                {errors.length === 0 && inputPassword1.length > 0 && inputPassword1 === inputPassword2 ?
                                                    (<>
                                                        <Icon path={mdiCheckCircle} size={1} color={"green"} />
                                                    </>) : null
                                                }
                                            </SpaceBetween>
                                        </FormField>
                                        <Button onClick={handleValidateNewPasword} disabled={isDisabledBtnMod} variant="primary">Modificar</Button>
                                    </SpaceBetween>

                                </Container>
                            </SpaceBetween>

                        </Form>
                    </form>
                }
            />
        </>
    );
};

